import React, { useEffect, useRef, useState } from "react";
import Layout from "../../components/layouts/Layout";
import BreadcrumbBlock from "../../components/BreadcrumbBlock/BreadcrumbBlock";
import { Link } from "react-router-dom";
import {
  Button,
  Flex,
  Input,
  PaginationProps,
  Select,
  SelectProps,
  Table,
  TableColumnsType,
  notification,
  Image,
  Tabs,
  TabsProps,
  Tooltip,
} from "antd";
import {
  ArrangeVertical,
  ArrowSquareDown,
  Clock,
  Crown,
  DocumentDownload,
  Home2,
  SearchZoomIn1,
} from "iconsax-react";
import {
  ArrowDownOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  ArrowUpOutlined,
  FileOutlined,
  EyeOutlined,
  StopOutlined,
} from "@ant-design/icons";
import HistoryPopup from "./HistoryPopup";
import LockModal from "../../components/Modal/LockModal";
import EditLevelModal from "../../components/Modal/EditLevelModal";
import EditMemberPopup from "./EditMemberPopup";
import AddMemberModal from "./Components/AddMember";
import SendMessageModal from "../../components/Modal/SendMessage";
import { mixGetV1, mixPostV1, mixPutV1 } from "../../services/mixin";
import * as XLSX from "xlsx";
import { API_URL, IMAGE_URL, fallbackAvatar } from "../../env";
import MemberDetailInfomationPoup from "./MemberDetailInfomationPoup";
import "./style.scss";

const pencil = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1265_4186)">
      <path
        d="M14.167 2.49993C14.3859 2.28106 14.6457 2.10744 14.9317 1.98899C15.2176 1.87054 15.5241 1.80957 15.8337 1.80957C16.1432 1.80957 16.4497 1.87054 16.7357 1.98899C17.0216 2.10744 17.2815 2.28106 17.5003 2.49993C17.7192 2.7188 17.8928 2.97863 18.0113 3.2646C18.1297 3.55057 18.1907 3.85706 18.1907 4.16659C18.1907 4.47612 18.1297 4.78262 18.0113 5.06859C17.8928 5.35455 17.7192 5.61439 17.5003 5.83326L6.25033 17.0833L1.66699 18.3333L2.91699 13.7499L14.167 2.49993Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1265_4186">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const lock = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 15V12.5M13.125 9.375V5C13.125 3.27411 11.7259 1.875 10 1.875C8.27411 1.875 6.875 3.27411 6.875 5V9.375M3.75 16.875V10.625C3.75 9.93464 4.30964 9.375 5 9.375H15C15.6904 9.375 16.25 9.93464 16.25 10.625V16.875C16.25 17.5654 15.6904 18.125 15 18.125H5C4.30964 18.125 3.75 17.5654 3.75 16.875Z"
      stroke="#F5222D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const unlock = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 15V12.5M13.125 5C13.125 3.27411 11.7259 1.875 10 1.875C8.27411 1.875 6.875 3.27411 6.875 5V9.375M3.75 16.875V10.625C3.75 9.93464 4.30964 9.375 5 9.375H15C15.6904 9.375 16.25 9.93464 16.25 10.625V16.875C16.25 17.5654 15.6904 18.125 15 18.125H5C4.30964 18.125 3.75 17.5654 3.75 16.875Z"
      stroke="#0CAF60"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

type LabelRender = SelectProps["labelRender"];

const customSelectedLabel: LabelRender = (props) => {
  const { label } = props;

  if (label) {
    return (
      <Flex align="center" gap={8}>
        <Crown size={20} variant="Bulk" style={{ minWidth: 20 }} />
        <span>
          Role (<span className="text-active">{label}</span>)
        </span>
      </Flex>
    );
  }
  return (
    <Flex align="center" gap={8}>
      <Crown size={20} variant="Bulk" style={{ minWidth: 20 }} />
      <span>Role</span>
    </Flex>
  );
};

const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement,
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};

// CHECK ROLE = 'USER'
const user = JSON.parse(localStorage.getItem("user") || "{}");
const permission = user.permission;
const memberRole = permission
  ? permission.find((item: any) => item.function_id === 3)
  : null;

export interface HistoryMatch {
  cash_out: number;
  date_checkin: string;
  id: number;
  machine_number: string;
  match_amount: number;
  shift: string;
  time_checkin: string;
  voucher_id: number;
}

export interface HistoryLuckyGame {
  id: number;
  label_id: number;
  name: string;
  award_date: string;
  phone_number: string;
}

const Member: React.FC = () => {
  const [showHistoryPopup, setShowHistoryPopup] = useState(false);
  const [showEditMemberPopup, setShowEditMemberPopup] = useState(false);
  const [showAddMemberModal, setShowAddMemberModal] = useState(false);
  const [showSendSMSModal, setShowSendSMSModal] = useState(false);
  const [showLockPopup, setShowLockPopup] = useState(false);
  const [selectedId, setSelectedId] = useState<number>();
  const [selectedItem, setSelectedItem] = useState<any>();
  const [smsMembers, setSmsMembers] = useState<any>();
  const [showMemberInfoPopup, setShowMemberInfoPopup] = useState(false);
  const [selectedMemberID, setSelectedMemberID] = useState<any>(null);
  const [infoCustomer, setInfomationCustomer] = useState<any>(null);
  const [historyMatch, setHistoryMatch] = useState<HistoryMatch[]>([]);
  const [showBanPopup, setShowBanPopup] = useState(false);
  const [paramsMatch, setparamsMatch] = useState<{
    totalRowMatch: number;
    page_number: number;
    limit: number;
    pageName: string;
    totalRowGame: number;
    page_number_game: number;
    x: number;
  }>({
    totalRowMatch: 0,
    page_number: 1,
    limit: 10,
    pageName: "match",
    totalRowGame: 0,
    page_number_game: 1,
    x: 0,
  });
  const [loading] = useState(false);
  const [historyLuckyGame, setHistoryLuckyGame] = useState<HistoryLuckyGame[]>(
    [],
  );
  const comboLimit = [
    { value: 0, label: "None" },
    { value: 1, label: 1 },
    { value: 2, label: 2 },
    { value: 3, label: 3 },
    { value: 4, label: 4 },
    { value: 5, label: 5 },
    { value: 6, label: 6 },
    { value: 7, label: 7 },
    { value: 8, label: 8 },
    { value: 9, label: 9 },
  ];
  const [visibleTooltipId, setVisibleTooltipId] = useState<string | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const gInfomationCustomer = async () => {
    const res = await mixPostV1(
      "/api/webAdmin/gDetailInfomationCustomerOfStore.php",
      { customer_id: selectedMemberID },
    );
    if (res.status === 1) {
      setInfomationCustomer(res.data);
    } else {
      setInfomationCustomer(null);
    }
  };

  const gHistoryMatch = async () => {
    const param = {
      page_number: paramsMatch.page_number,
      limit: paramsMatch.limit,
      customer_id: selectedMemberID,
    } as any;
    const res = await mixPostV1(
      "/api/webAdmin/gListHistoryMatchCustomer.php",
      param,
    );
    if (res.status === 1) {
      setHistoryMatch(res.data);
      setparamsMatch({ ...paramsMatch, totalRowMatch: res.total });
    } else {
      setHistoryMatch([]);
    }
  };

  const onPageMatchChange = (page: number) => {
    setparamsMatch({
      ...paramsMatch,
      page_number: page,
      pageName: "match",
      x: paramsMatch.x + 1,
    });
  };

  const onTableMatchChange = (data: any) => {
    setparamsMatch({
      ...paramsMatch,
      page_number: data.current,
      limit: data.pageSize,
      pageName: "match",
      x: paramsMatch.x + 1,
    });
  };

  const gHistoryLuckyGame = async () => {
    const param = {
      page_number: paramsMatch.page_number_game,
      limit: paramsMatch.limit,
      customer_id: selectedMemberID,
    } as any;
    const res = await mixPostV1(
      "/api/webAdmin/gHistoryLuckyGamecustomer.php",
      param,
    );
    if (res.status === 1) {
      setHistoryLuckyGame(res.data);
      setparamsMatch({ ...paramsMatch, totalRowGame: res.total });
    } else {
      setHistoryLuckyGame([]);
    }
  };

  const onPageGameChange = (page: number) => {
    setparamsMatch({
      ...paramsMatch,
      page_number_game: page,
      pageName: "game",
      x: paramsMatch.x + 1,
    });
  };

  const onTableGameChange = (data: any) => {
    setparamsMatch({
      ...paramsMatch,
      page_number_game: data.current,
      limit: data.pageSize,
      pageName: "game",
      x: paramsMatch.x + 1,
    });
  };

  useEffect(() => {
    if (selectedMemberID) {
      gInfomationCustomer();
      gHistoryMatch();
      gHistoryLuckyGame();
    }
  }, [selectedMemberID, showMemberInfoPopup]);

  useEffect(() => {
    if (paramsMatch.x !== 0) {
      if (paramsMatch.pageName === "game") {
        gHistoryLuckyGame();
      } else {
        gHistoryMatch();
      }
    }
  }, [paramsMatch.x]);

  const handleTooltipChange = (visible: boolean, recordId: string) => {
    if (visible) {
      setVisibleTooltipId(recordId);
      timeoutRef.current = setTimeout(() => {
        setVisibleTooltipId(null);
      }, 2000);
    } else {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      setVisibleTooltipId(null);
    }
  };

  const [modalData, setModalData] = useState({
    show: false,
    data: {},
  } as any);

  // TABLE
  const columns: TableColumnsType = [
    {
      title: "",
      key: "actions",
      fixed: "left",
      className: "actions-sticky actions-sticky--left",
      width: 160,
      render: (_, record) => (
        <Flex align="center" gap={4}>
          <Button
            title="View"
            icon={<FileOutlined />}
            className="rs-button"
            disabled={memberRole && memberRole.is_view === 0}
            onClick={() => {
              setSelectedId(record.customer_id);
              setShowHistoryPopup(true);
            }}
          />
          <Button
            title={record.statusLock === 1 ? "Unlock" : "Block"}
            icon={record.statusLock === 1 ? lock : unlock}
            className="rs-button"
            disabled={memberRole && memberRole.is_edit === 0}
            onClick={() => {
              setSelectedItem(record);
              setShowLockPopup(true);
            }}
          />
          <Button
            title="Ban"
            icon={<StopOutlined />}
            className="rs-button"
            disabled={memberRole && memberRole.is_edit === 0}
            style={{ color: record.is_bandit === 1 ? "red" : "inherit" }}
            onClick={() => {
              setSelectedItem(record);
              setShowBanPopup(true);
            }}
          />
          <Button
            title="Edit"
            icon={pencil}
            className="rs-button edit"
            disabled={memberRole && memberRole.is_edit === 0}
            onClick={() => {
              setSelectedId(record.customer_id);
              setShowEditMemberPopup(true);
            }}
          />
        </Flex>
      ),
    },
    {
      title: "No.",
      key: "stt",
      width: 70,
      align: "center",
      render: (_: any, __: any, index: number) =>
        (params.page_number - 1) * params.limit + index + 1,
    },
    {
      title: "App ID",
      dataIndex: "appId",
      key: "appId",
      render: (_, record) => (
        <div
          className={`${
            Number(record.check_in_limit) > 0 ? "text-warning" : ""
          }`}
        >
          {record.app_id}
        </div>
      ),
    },
    {
      title: "Customer name",
      dataIndex: "name",
      key: "name",
      render: (_, record) => (
        <div
          className={`${
            Number(record.check_in_limit) > 0 ? "text-warning" : ""
          }`}
        >
          {record.name}
        </div>
      ),
    },
    {
      title: "Member Face",
      dataIndex: "face",
      key: "face",
      render: (_, record) => (
        <Flex align="center" gap={12}>
          <Image
            height={40}
            width={40}
            src={
              record.avatar ? `${IMAGE_URL}${record.avatar}` : fallbackAvatar
            }
            alt={record.name}
            preview={
              record.avatar ? { src: `${IMAGE_URL}${record.avatar}` } : false
            }
            fallback={fallbackAvatar}
            style={{
              borderRadius: "50%",
              overflow: "hidden",
              objectFit: "cover",
            }}
          />
        </Flex>
      ),
    },
    {
      title: "Palm Scan",
      dataIndex: "hand",
      key: "img_hand",
      render: (_, record) => (
        <Flex align="center" gap={12}>
          {record.is_manual === 1 ? (
            <span>Manual</span>
          ) : (
            <Image
              height={40}
              width={40}
              src={
                record.img_hand
                  ? `${IMAGE_URL}${record.img_hand}`
                  : fallbackAvatar
              }
              alt={record.name}
              preview={
                record.img_hand
                  ? { src: `${IMAGE_URL}${record.img_hand}` }
                  : false
              }
              fallback={fallbackAvatar}
              style={{
                borderRadius: "50%",
                overflow: "hidden",
                objectFit: "cover",
              }}
            />
          )}
        </Flex>
      ),
    },
    {
      title: "Phone number",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Shift",
      dataIndex: "shift",
      key: "shift",
      render: (text, record) => (
        <Flex align="center" gap={12}>
          {record.is_out_shift === 1 ? (
            <span>Out of Shift</span>
          ) : (
            <span>{text}</span>
          )}
        </Flex>
      ),
    },
    {
      title: "Machine",
      dataIndex: "machine_number",
      key: "machine_number",
    },
    {
      title: "Time",
      dataIndex: "time_checkin",
      key: "time_checkin",
      render: (text, record) => (
        <>
          {text}, {record.date_checkin}
        </>
      ),
    },
    {
      title: "Level",
      dataIndex: "level",
      key: "level",
      align: "right",
      sorter: true,
      sortIcon: ({ sortOrder }) =>
        sortOrder === "ascend" ? (
          <ArrowDownOutlined style={{ marginInlineStart: 8 }} />
        ) : sortOrder === "descend" ? (
          <ArrowUpOutlined style={{ marginInlineStart: 8 }} />
        ) : (
          <ArrangeVertical size={12} style={{ marginInlineStart: 8 }} />
        ),
      render: (text, record) => (
        <span
          className="ctr-editlv"
          onClick={() => {
            if (memberRole && memberRole.is_edit === 0) {
              openNotification(
                "error",
                "You don't have permission to edit this member",
              );
              return;
            }
            setModalData({ ...modalData, show: true, data: record });
          }}
        >
          {text.toString()}
        </span>
      ),
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      align: "right",
      sorter: true,
      sortIcon: ({ sortOrder }) =>
        sortOrder === "ascend" ? (
          <ArrowDownOutlined style={{ marginInlineStart: 8 }} />
        ) : sortOrder === "descend" ? (
          <ArrowUpOutlined style={{ marginInlineStart: 8 }} />
        ) : (
          <ArrangeVertical size={12} style={{ marginInlineStart: 8 }} />
        ),
    },
    {
      title: "Match",
      dataIndex: "match",
      key: "match",
      align: "right",
      sorter: true,
      sortIcon: ({ sortOrder }) =>
        sortOrder === "ascend" ? (
          <ArrowDownOutlined style={{ marginInlineStart: 8 }} />
        ) : sortOrder === "descend" ? (
          <ArrowUpOutlined style={{ marginInlineStart: 8 }} />
        ) : (
          <ArrangeVertical size={12} style={{ marginInlineStart: 8 }} />
        ),
    },
    {
      title: "Cashout",
      dataIndex: "cashout",
      key: "cashout",
      align: "right",
      sorter: true,
      sortIcon: ({ sortOrder }) =>
        sortOrder === "ascend" ? (
          <ArrowDownOutlined style={{ marginInlineStart: 8 }} />
        ) : sortOrder === "descend" ? (
          <ArrowUpOutlined style={{ marginInlineStart: 8 }} />
        ) : (
          <ArrangeVertical size={12} style={{ marginInlineStart: 8 }} />
        ),
    },
    {
      title: (
        <div style={{ textAlign: "center", fontWeight: 600 }}>
          Customize Member
        </div>
      ),
      className: "customize-header",
      children: [
        {
          title: "Times",
          dataIndex: "check_in_limit",
          key: "check_in_limit",
          align: "center",
          className: "customize-cell",
          render: (_, record) => (
            <Flex align="center" justify="center" gap={12}>
              <Tooltip
                title="A customer can claim a voucher in a day"
                placement="bottom"
                open={visibleTooltipId === `${record.id}-limit`}
                onOpenChange={(visible) =>
                  handleTooltipChange(visible, `${record.id}-limit`)
                }
              >
                <Select
                  value={Number(record.check_in_limit) || 0}
                  options={comboLimit}
                  placeholder="None"
                  allowClear={false}
                  popupMatchSelectWidth={false}
                  suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
                  className="rs-select w-186 grid-area-level value-limit"
                  onChange={(e) => {
                    if (memberRole && memberRole.is_edit === 0) {
                      openNotification(
                        "error",
                        "You don't have permission to edit this member",
                      );
                      return;
                    }
                    updateLimitMember(e, record.app_id);
                  }}
                />
              </Tooltip>
            </Flex>
          ),
        },
        {
          title: "Hours",
          dataIndex: "hour_allow_match",
          key: "hour_allow_match",
          align: "center",
          className: "customize-cell",
          render: (_, record) => (
            <Flex align="center" justify="center" gap={12}>
              <Tooltip
                title="The times between 2 matches"
                placement="bottom"
                open={visibleTooltipId === `${record.id}-hour`}
                onOpenChange={(visible) =>
                  handleTooltipChange(visible, `${record.id}-hour`)
                }
              >
                <Select
                  value={Number(record.hour_allow_match) || 0}
                  options={comboLimit}
                  placeholder="None"
                  allowClear={false}
                  popupMatchSelectWidth={false}
                  suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
                  className="rs-select w-186 grid-area-level value-limit"
                  onChange={(e) => {
                    if (memberRole && memberRole.is_edit === 0) {
                      openNotification(
                        "error",
                        "You don't have permission to edit this member",
                      );
                      return;
                    }
                    updateHourMatchMember(e, record.app_id);
                  }}
                />
              </Tooltip>
            </Flex>
          ),
        },
      ],
    },
  ];
  // END TABLE

  // GET USER ROLES
  const [roles, setRoles] = useState([] as any);
  const getUserRoles = async () => {
    const res = await mixGetV1("/api/webAdmin/gComboRoleCustoomer.php", {});

    if (res.status === 1) {
      const result: any = [];

      res.data.map((item: any) =>
        result.push({
          ...item,
          value: item.role_id,
          label: item.role_name,
        }),
      );

      setRoles(result);
    }
  };
  useEffect(() => {
    getUserRoles();
    getLevels();
  }, []);
  // END GET USER ROLES

  // GET LIST
  const [items, setItems] = useState({
    list: [],
    total: 0,
  });
  const [tableLoading, setTableLoading] = useState(false);

  const [params, setParams] = useState<{
    customer_type: number;
    limit: number;
    page_number: number;
    searchKey?: string;
    roleSearch?: string;
    levelSearch?: string;
    entryMethodSearch?: string;
    searchShift?: string;
    sortBy?: string;
    sortType?: string;
  }>({
    customer_type: 2,
    limit: 10,
    page_number: 1,
  });

  const getItems = async () => {
    setTableLoading(true);
    const result: any = [];

    try {
      const res = await mixPostV1(
        "/api/webAdmin/gListCustomerByStore.php",
        params,
      );

      if (res.status === 1) {
        res.data.forEach((item: any, index: number) => {
          result.push({
            ...item,
            key: index,
            appId: item.app_id,
            name: item.customer_name,
            phone: item.phone_number,
            level: item.level,
            role: item.role_name,
            match: item.match_amount,
            cashout: item.cash_out,
            avatar: item.avatar || "/images/avatar.png",
            face: item.date_checkin,
            statusLock: item.is_locked,
            img_hand: item.img_hand,
            is_bandit: item.is_bandit,
            is_out_shift: item.is_out_shift,
          });
        });
        setItems({
          ...items,
          list: result,
          total: res.total,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTableLoading(false);
    }
  };

  useEffect(() => {
    getItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
    });
  };

  const onTableChange = (pagination: any, _: any, sorter: any) => {
    let sortBy = "";
    let sortType = "";

    if (sorter) {
      const { field, order } = sorter;
      sortType = order === "descend" ? "DESC" : "ASC";
      sortBy = field;

      if (!order) {
        sortType = "";
        sortBy = "";
      }
    }

    setParams({
      ...params,
      sortType,
      sortBy,
      page_number: pagination.current,
      limit: pagination.pageSize,
    });
  };
  // END GET LIST

  // LEVELS
  const [levels, setLevels] = useState([] as any);
  const getLevels = async () => {
    try {
      const res = await mixPostV1("/api/webAdmin/gComboLevelSetting.php", {});
      if (res.status === 1) {
        const data = res.data.map((item: any) => ({
          value: item.level_name,
          label: item.level_name,
        }));
        data.sort((a: any, b: any) => a.value - b.value);
        setLevels([{ value: 0, label: 0 }, ...data]);
      }
    } catch (error) {}
  };
  const onFilterLevel = (value: any) => {
    if (value === undefined) {
      setParams({
        ...params,
        page_number: 1,
        levelSearch: "",
      });
      setParams0({
        ...params0,
        page_number: 1,
        levelSearch: "",
      });
    } else {
      setParams({
        ...params,
        page_number: 1,
        levelSearch: value,
      });
      setParams0({
        ...params0,
        page_number: 1,
        levelSearch: value,
      });
    }
  };

  const onFilterEntryMethod = (value: any) => {
    if (value === undefined) {
      setParams({
        ...params,
        page_number: 1,
        entryMethodSearch: "",
      });
      setParams0({
        ...params0,
        page_number: 1,
        entryMethodSearch: "",
      });
    } else {
      setParams({
        ...params,
        page_number: 1,
        entryMethodSearch: value,
      });
      setParams0({
        ...params0,
        page_number: 1,
        entryMethodSearch: value,
      });
    }
  };
  // END LEVELS

  // SEARCH
  const [searchTimeout, setSearchTimeout] = useState<any>(null);
  const onSearch = (query: string) => {
    setParams({
      ...params,
      page_number: 1,
      searchKey: query,
    });
    setParams0({
      ...params0,
      page_number: 1,
      searchKey: query,
    });
    setParams2({
      ...params0,
      page_number: 1,
      searchKey: query,
    });
  };
  const onEnter = (e: any) => {
    onSearch(e.target.value);
  };
  const onChange = (e: any) => {
    clearTimeout(searchTimeout);
    const timeout = setTimeout(() => {
      onSearch(e.target.value);
    }, 250);
    setSearchTimeout(timeout);
  };
  // END SEARCH

  // ROLE CHANGE
  const onRoleChange = (value: any) => {
    if (value) {
      setParams({
        ...params,
        page_number: 1,
        roleSearch: value,
      });
      setParams0({
        ...params,
        page_number: 1,
        roleSearch: value,
      });
    } else {
      setParams({
        ...params,
        page_number: 1,
        roleSearch: "",
      });
      setParams0({
        ...params,
        page_number: 1,
        roleSearch: value,
      });
    }
  };
  // END ROLE CHANGE

  // SHIFT CHANGE
  const [shiftTimeout, setShiftTimeout] = useState<any>(null);
  const onShiftFilter = (query: string) => {
    setParams({
      ...params,
      page_number: 1,
      searchShift: query,
    });
  };
  const onShiftEnter = (e: any) => {
    onShiftFilter(e.target.value);
  };
  const onShiftChange = (e: any) => {
    clearTimeout(shiftTimeout);
    const timeout = setTimeout(() => {
      onShiftFilter(e.target.value);
    }, 250);
    setShiftTimeout(timeout);
  };
  // END SHIFT CHANGE

  // EXPORT PALM IMAGES
  const [exportPalmLoading, setExportPalmLoading] = useState(false);
  const handleExportPalmImages = async () => {
    const storeId = localStorage.getItem("storeId") || user?.store_id;
    if (!storeId) {
      openNotification("error", "Store ID not found!");
      return;
    }

    setExportPalmLoading(true);
    openNotification("success", "Preparing download file...");

    try {
      const response = await fetch(
        `${API_URL}/api/webAdmin/downloadPalmsByRegId.php?store_id=${storeId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const responseClone = response.clone();
      const contentType = response.headers.get("content-type") || "";

      const triggerUrlDownload = (fileUrl: string) => {
        let fullUrl = fileUrl;
        if (!fileUrl.startsWith("http://") && !fileUrl.startsWith("https://")) {
          fullUrl = fileUrl.startsWith("/")
            ? `${API_URL}${fileUrl}`
            : `${API_URL}/api/webAdmin/${fileUrl}`;
        }
        const link = document.createElement("a");
        link.href = fullUrl;
        link.setAttribute("download", `palms_store_${storeId}.zip`);
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        link.remove();
      };

      const handleJsonResponse = (json: any) => {
        console.log("downloadPalms JSON response:", json);
        const isSuccess =
          json.status === 1 ||
          json.status === true ||
          json.status === 200 ||
          json.success === true;

        if (isSuccess) {
          openNotification(
            "success",
            json.message || json.msg || "Palm images exported successfully!",
          );
          const rawUrl =
            json.url ||
            json.file ||
            json.path ||
            json.data ||
            json.download_url ||
            json.zip_url ||
            json.link ||
            json.file_url ||
            json.zip;

          if (rawUrl && typeof rawUrl === "string") {
            triggerUrlDownload(rawUrl);
          } else {
            triggerUrlDownload(`palms_store_${storeId}.zip`);
          }
        } else {
          openNotification(
            "error",
            json.message || json.msg || "No palm images available to export.",
          );
        }
      };

      if (contentType.includes("application/json")) {
        const json = await response.json();
        handleJsonResponse(json);
        return;
      }

      const blob = await response.blob();

      if (blob.size < 2000) {
        const text = await responseClone.text();
        if (text.trim().startsWith("{")) {
          try {
            const json = JSON.parse(text);
            handleJsonResponse(json);
            return;
          } catch {}
        } else if (
          text.trim().startsWith("<html") ||
          text.trim().startsWith("<!DOCTYPE")
        ) {
          openNotification("error", "Server error while downloading file.");
          return;
        }
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `palms_store_${storeId}.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      openNotification("success", "Palm images exported successfully!");
    } catch (error) {
      console.error(error);
      openNotification("error", "Failed to export palm images!");
    } finally {
      setExportPalmLoading(false);
    }
  };

  // EXPORT EXCEL
  const [exportLoading, setExportLoading] = useState(false);
  const getItemsByExcel = async () => {
    setExportLoading(true);
    if (currentTab === "1") {
      const customParams = {
        ...params,
        page_number: 1,
        limit: 10000,
      };

      try {
        const res = await mixPostV1(
          "/api/webAdmin/gListCustomerByStore.php",
          customParams,
        );

        if (res.status) {
          if (res.data.length > 0) {
            formattedDataExcel(res.data);
            setExportLoading(false);
          } else {
            setExportLoading(false);
            openNotification("error", "There is no data to export!");
          }
        } else {
          setExportLoading(false);
          openNotification("error", "Oops, something went wrong!");
        }
      } catch (error) {
        setExportLoading(false);
        openNotification("error", "Oops, something went wrong!");
      }
    }

    if (currentTab === "2") {
      const customParams = {
        ...params0,
        page_number: 1,
        limit: 10000,
      };

      try {
        const res = await mixPostV1(
          "/api/webAdmin/gListAllDistinctCustomerOfStore.php",
          customParams,
        );

        if (res.status) {
          if (res.data.length > 0) {
            formattedDataExcel0(res.data);
            setExportLoading(false);
          } else {
            setExportLoading(false);
            openNotification("error", "There is no data to export!");
          }
        } else {
          setExportLoading(false);
          openNotification("error", "Oops, something went wrong!");
        }
      } catch (error) {
        setExportLoading(false);
        openNotification("error", "Oops, something went wrong!");
      }
    }

    if (currentTab === "3") {
      const customParams = {
        ...params2,
        page_number: 1,
        limit: 10000,
      };

      try {
        const res = await mixPostV1(
          "/api/webAdmin/gHistoryRejectMatch.php",
          customParams,
        );

        if (res.status) {
          if (res.data.length > 0) {
            formattedDataExcel2(res.data);
            setExportLoading(false);
          } else {
            setExportLoading(false);
            openNotification("error", "There is no data to export!");
          }
        } else {
          setExportLoading(false);
          openNotification("error", "Oops, something went wrong!");
        }
      } catch (error) {
        setExportLoading(false);
        openNotification("error", "Oops, something went wrong!");
      }
    }
  };
  const formattedDataExcel2 = (data: any) => {
    const formattedData = data.map((item: any) => {
      return {
        "App ID": item.customer_id,
        Name: item.customer_name,
        Staff: item.staff_name,
        "Time reject": item.date_reject,
        Match: item.match_amount,
        Reason: item.reason,
      };
    });
    exportExcel(formattedData, "Member reject list");
  };
  const formattedDataExcel0 = (data: any) => {
    const formattedData = data.map((item: any) => {
      return {
        "App ID": item.app_id,
        "Customer name": item.customer_name,
        "Phone number": item.phone_number,
        Time: item.time_joint,
        Level: item.level.toString(),
      };
    });
    exportExcel(formattedData);
  };
  const formattedDataExcel = (data: any) => {
    const formattedData = data.map((item: any) => {
      return {
        "App ID": item.app_id,
        "Customer name": item.customer_name,
        "Phone number": item.phone_number,
        Level: item.level.toString(),
        Role: item.role_name,
        Match: item.match_amount,
        "Cash out": item.cash_out,
        "Time checkin": item.time_checkin,
      };
    });
    exportExcel(formattedData, "Member check in list");
  };
  const exportExcel = (
    convertData: any,
    nameExcel = "Member list",
  ): boolean => {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách");

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
        const data: Blob = new Blob([buffer], {
          type: "application/octet-stream",
        });
        const link: HTMLAnchorElement = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = fileName;
        link.click();
      };

      saveAsExcel(excelBuffer, `${nameExcel}.xlsx`);
      return true;
    } catch (error) {
      console.error("Error exporting Excel:", error);
      return false;
    }
  };
  // END EXPORT EXCEL

  // EDIT LIMIT CHECKIN
  const updateLimitMember = async (value: any, id: number) => {
    const limitParams = {
      check_in_limit: value ? Number(value) : 0,
      customer_id: id,
    };

    try {
      const res = await mixPutV1(
        "/api/webAdmin/editLimitCheckinCustomer.php",
        limitParams,
      );

      if (res.status === 1) {
        openNotification("success", "Time updated!");
        getItems();
        getItems0();
        getLevels();
      } else {
        openNotification("error", res.message);
      }
    } catch (error) {
      openNotification("error", "Oops, something went wrong!");
    }
  };
  // EDIT HOUR ALLOW MATCH
  const updateHourMatchMember = async (value: any, id: number) => {
    const limitParams = {
      hour_allow_match: value ? Number(value) : 0,
      customer_id: id,
    };

    try {
      const res = await mixPutV1(
        "/api/webAdmin/editHourAllowMatchCustomer.php",
        limitParams,
      );

      if (res.status === 1) {
        openNotification("success", "Hour updated!");
        getItems();
        getItems0();
        getLevels();
      } else {
        openNotification("error", res.message);
      }
    } catch (error) {
      openNotification("error", "Oops, something went wrong!");
    }
  };

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "info" | "warning" | "error" = "success",
    message = "Level updated!",
  ) => {
    api[type]({
      message,
      placement: "bottomRight",
      className: "single-message",
    });
  };

  const [currentTab, setCurrentTab] = useState("1");
  // TABS
  const tabs: TabsProps["items"] = [
    {
      key: "1",
      label: (
        <div className="title-tab-setting">
          <div className="text t-fz-16">Check in</div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div className="title-tab-setting">
          <div className="text t-fz-16">All Member</div>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div className="title-tab-setting">
          <div className="text t-fz-16">Refund</div>
        </div>
      ),
    },
  ];

  const onTabChange = (key: string) => {
    setCurrentTab(key);
  };

  // GET LIST0
  const onTableChange0 = (pagination: any, _: any, sorter: any) => {
    let sortBy = "";
    let sortType = "";

    if (sorter) {
      const { field, order } = sorter;
      sortType = order === "descend" ? "DESC" : "ASC";
      sortBy = field;

      if (!order) {
        sortType = "";
        sortBy = "";
      }
    }

    setParams0({
      ...params0,
      sortType,
      sortBy,
      page_number: pagination.current,
      limit: pagination.pageSize,
    });
  };

  const onPageChange0 = (page: number) => {
    setParams0({
      ...params0,
      page_number: page,
    });
  };

  const columns0: TableColumnsType = [
    {
      title: "",
      key: "actions",
      fixed: "left",
      className: "actions-sticky actions-sticky--left",
      width: 50,
      render: (_, record) => (
        <Flex align="center" gap={4}>
          <Button
            title="Statistics"
            icon={<EyeOutlined />}
            className="rs-button eyeIcon"
            onClick={() => {
              setSelectedMemberID(record.customer_id);
              setShowMemberInfoPopup(true);
            }}
          />
          <Button
            title="Edit"
            icon={pencil}
            className="rs-button edit"
            disabled={memberRole && memberRole.is_edit === 0}
            onClick={() => {
              setSelectedId(record.app_id);
              setShowEditMemberPopup(true);
            }}
          />
          <Button
            title={record.statusLock === 1 ? "Unlock" : "Block"}
            icon={record.statusLock === 1 ? lock : unlock}
            className="rs-button"
            disabled={memberRole && memberRole.is_edit === 0}
            onClick={() => {
              setSelectedItem(record);
              setShowLockPopup(true);
            }}
          />
          <Button
            title="Banned"
            icon={
              <StopOutlined
                style={{ color: record.is_bandit === 1 ? "red" : "inherit" }}
              />
            }
            className="rs-button"
            disabled={memberRole && memberRole.is_edit === 0}
            onClick={() => {
              setSelectedItem(record);
              setShowBanPopup(true);
            }}
          />
        </Flex>
      ),
    },
    {
      title: "No.",
      key: "stt",
      width: 70,
      align: "center",
      render: (_: any, __: any, index: number) =>
        (params0.page_number - 1) * params0.limit + index + 1,
    },
    {
      title: "App ID",
      dataIndex: "appId",
      key: "appId",
      render: (_, record) => (
        <div
          className={`${
            Number(record.check_in_limit) > 0 ? "text-warning" : ""
          }`}
        >
          {record.app_id}
        </div>
      ),
    },
    {
      title: "Customer name",
      dataIndex: "name",
      key: "name",
      render: (_, record) => (
        <div
          className={`${
            Number(record.check_in_limit) > 0 ? "text-warning" : ""
          }`}
        >
          {record.name}
        </div>
      ),
    },
    {
      title: "Member Face",
      dataIndex: "face",
      key: "face",
      render: (text, record) => (
        <Flex align="center" gap={12}>
          <Image
            height={40}
            width={40}
            src={
              record.avatar ? `${IMAGE_URL}${record.avatar}` : fallbackAvatar
            }
            alt={record.name}
            preview={
              record.avatar ? { src: `${IMAGE_URL}${record.avatar}` } : false
            }
            fallback={fallbackAvatar}
            style={{
              borderRadius: "50%",
              overflow: "hidden",
              objectFit: "cover",
            }}
          />
          <span>{text}</span>
        </Flex>
      ),
    },
    {
      title: "Palm Registration",
      dataIndex: "handCheckin",
      key: "hand_register",
      render: (text, record) =>
        record?.is_manual === 1 ? (
          <p>Manual</p>
        ) : (
          <Flex align="center" gap={12}>
            <Image
              height={40}
              width={40}
              src={
                record.hand_register
                  ? `${IMAGE_URL}${record.hand_register}`
                  : fallbackAvatar
              }
              alt={record.name}
              preview={
                record.hand_register
                  ? { src: `${IMAGE_URL}${record.hand_register}` }
                  : false
              }
              fallback={fallbackAvatar}
              style={{
                borderRadius: "50%",
                overflow: "hidden",
                objectFit: "cover",
              }}
            />
            <span>{text}</span>
          </Flex>
        ),
    },
    {
      title: "Phone number",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Time",
      dataIndex: "time_checkin",
      key: "time_checkin",
      render: (_, record) => <>{record.time_joint}</>,
    },
    {
      title: "Level",
      dataIndex: "level",
      key: "level",
      align: "right",
      sorter: true,
      sortIcon: ({ sortOrder }) =>
        sortOrder === "ascend" ? (
          <ArrowDownOutlined style={{ marginInlineStart: 8 }} />
        ) : sortOrder === "descend" ? (
          <ArrowUpOutlined style={{ marginInlineStart: 8 }} />
        ) : (
          <ArrangeVertical size={12} style={{ marginInlineStart: 8 }} />
        ),
      render: (text, record) => (
        <span
          className="ctr-editlv"
          onClick={() => {
            if (memberRole && memberRole.is_edit === 0) {
              openNotification(
                "error",
                "You don't have permission to edit this member",
              );
              return;
            }
            setModalData({ ...modalData, show: true, data: record });
          }}
        >
          {text.toString()}
        </span>
      ),
    },
    {
      title: (
        <div style={{ textAlign: "center", fontWeight: 600 }}>
          Customize Member
        </div>
      ),
      className: "customize-header",
      children: [
        {
          title: "Times",
          dataIndex: "check_in_limit",
          key: "check_in_limit",
          align: "center",
          className: "customize-cell",
          render: (_, record) => (
            <Flex align="center" justify="center" gap={12}>
              <Tooltip
                title="A customer can claim a voucher in a day"
                placement="bottom"
                open={visibleTooltipId === `${record.app_id}-limit`}
                onOpenChange={(visible) =>
                  handleTooltipChange(visible, `${record.app_id}-limit`)
                }
              >
                <Select
                  value={Number(record.check_in_limit) || 0}
                  options={comboLimit}
                  placeholder="None"
                  allowClear={false}
                  popupMatchSelectWidth={false}
                  suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
                  className="rs-select w-186 grid-area-level value-limit"
                  onChange={(e) => {
                    if (memberRole && memberRole.is_edit === 0) {
                      openNotification(
                        "error",
                        "You don't have permission to edit this member",
                      );
                      return;
                    }
                    updateLimitMember(e, record.app_id);
                  }}
                />
              </Tooltip>
            </Flex>
          ),
        },
        {
          title: "Hours",
          dataIndex: "hour_allow_match",
          key: "hour_allow_match",
          align: "center",
          className: "customize-cell",
          render: (_, record) => (
            <Flex align="center" justify="center" gap={12}>
              <Tooltip
                title="The times between 2 matches"
                placement="bottom"
                open={visibleTooltipId === `${record.app_id}-hour`}
                onOpenChange={(visible) =>
                  handleTooltipChange(visible, `${record.app_id}-hour`)
                }
              >
                <Select
                  value={Number(record.hour_allow_match) || 0}
                  options={comboLimit}
                  placeholder="None"
                  allowClear={false}
                  popupMatchSelectWidth={false}
                  suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
                  className="rs-select w-186 grid-area-level value-limit"
                  onChange={(e) => {
                    if (memberRole && memberRole.is_edit === 0) {
                      openNotification(
                        "error",
                        "You don't have permission to edit this member",
                      );
                      return;
                    }
                    updateHourMatchMember(e, record.app_id);
                  }}
                />
              </Tooltip>
            </Flex>
          ),
        },
      ],
    },
  ];
  // END TABLE

  const [items0, setItems0] = useState({
    list: [],
    total: 0,
    total_bandit: 0,
  });
  const [tableLoading0, setTableLoading0] = useState(false);

  const [params0, setParams0] = useState<{
    customer_type: number;
    limit: number;
    page_number: number;
    searchKey?: string;
    roleSearch?: string;
    levelSearch?: string;
    entryMethodSearch?: string;
    searchShift?: string;
    sortBy?: string;
    sortType?: string;
  }>({
    customer_type: 2,
    limit: 10,
    page_number: 1,
  });

  const getItems0 = async () => {
    setTableLoading0(true);
    const result: any = [];

    try {
      const res = await mixPostV1(
        "/api/webAdmin/gListAllDistinctCustomerOfStore.php",
        params0,
      );

      if (res.status === 1) {
        res.data.forEach((item: any, index: number) => {
          result.push({
            ...item,
            customer_id: item.app_id,
            key: index,
            appId: item.app_id,
            name: item.customer_name,
            phone: item.phone_number,
            level: item.level,
            role: item.role_name,
            match: item.match_amount,
            cashout: item.cash_out,
            avatar: item.avatar || "/images/avatar.png",
            face: item.date_checkin,
            statusLock: item.is_locked,
            hand_register: item.hand_register,
            is_bandit: item.is_bandit,
          });
        });
        setItems0({
          ...items0,
          list: result,
          total: res.total,
          total_bandit: res.total_bandit,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTableLoading0(false);
    }
  };

  useEffect(() => {
    getItems0();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params0]);

  const [totalMatchToday, setTotalMatchToday] = useState(0);
  const getItems1 = async () => {
    try {
      const res = await mixPostV1("/api/webAdmin/gTotalMatchToday.php", {});
      if (res.status === 1) {
        setTotalMatchToday(res.data.total_match_today);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getItems1();
  }, []);

  // GET LIST2
  const onTableChange2 = (pagination: any, _: any, sorter: any) => {
    let sortBy = "";
    let sortType = "";

    if (sorter) {
      const { field, order } = sorter;
      sortType = order === "descend" ? "DESC" : "ASC";
      sortBy = field;

      if (!order) {
        sortType = "";
        sortBy = "";
      }
    }

    setParams2({
      ...params2,
      sortType,
      sortBy,
      page_number: pagination.current,
      limit: pagination.pageSize,
    });
  };

  const onPageChange2 = (page: number) => {
    setParams2({
      ...params2,
      page_number: page,
    });
  };

  const columns2: TableColumnsType = [
    {
      title: "",
      key: "actions",
      fixed: "left",
      className: "actions-sticky actions-sticky--left",
      width: 160,
      render: (_, record) => (
        <Flex align="center" gap={4}>
          <Button
            title="View"
            icon={<FileOutlined />}
            className="rs-button"
            disabled={memberRole && memberRole.is_view === 0}
            onClick={() => {
              setSelectedId(record.customer_id);
              setShowHistoryPopup(true);
            }}
          />
          <Button
            title={record.statusLock === 1 ? "Unlock" : "Block"}
            icon={record.statusLock === 1 ? lock : unlock}
            className="rs-button"
            disabled={memberRole && memberRole.is_edit === 0}
            onClick={() => {
              setSelectedItem(record);
              setShowLockPopup(true);
            }}
          />
          <Button
            title="Ban"
            icon={
              <StopOutlined
                style={{ color: record.is_bandit === 1 ? "red" : "inherit" }}
              />
            }
            className="rs-button"
            disabled={memberRole && memberRole.is_edit === 0}
            onClick={() => {
              setSelectedItem(record);
              setShowBanPopup(true);
            }}
          />
        </Flex>
      ),
    },
    {
      title: "No.",
      key: "stt",
      width: 70,
      align: "center",
      render: (_: any, __: any, index: number) =>
        (params2.page_number - 1) * params2.limit + index + 1,
    },
    {
      title: "App ID",
      dataIndex: "customer_id",
      key: "customer_id",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Staff",
      dataIndex: "staff_name",
      key: "staff_name",
    },
    {
      title: "Time Match",
      dataIndex: "date_match",
      key: "date_match",
    },
    {
      title: "Time reject",
      dataIndex: "date_reject",
      key: "date_reject",
    },
    {
      title: "Match",
      dataIndex: "match_amount",
      key: "match_amount",
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
    },
  ];

  const [items2, setItems2] = useState({
    list: [],
    total: 0,
  });
  const [tableLoading2, setTableLoading2] = useState(false);

  const [params2, setParams2] = useState<{
    customer_type: number;
    limit: number;
    page_number: number;
    searchKey?: string;
    roleSearch?: string;
    levelSearch?: string;
    entryMethodSearch?: string;
    searchShift?: string;
    sortBy?: string;
    sortType?: string;
  }>({
    customer_type: 2,
    limit: 10,
    page_number: 1,
  });

  const getItems2 = async () => {
    setTableLoading2(true);
    const result: any = [];

    try {
      const res = await mixPostV1(
        "/api/webAdmin/gHistoryRejectMatch.php",
        params2,
      );

      if (res.status === 1) {
        res.data.forEach((item: any, index: number) => {
          result.push({
            ...item,
            key: index,
            appId: item.app_id,
            name: item.customer_name,
            phone: item.phone_number,
            level: item.level,
            role: item.role_name,
            match: item.match_amount,
            cashout: item.cash_out,
            avatar: item.avatar || "/images/avatar.png",
            face: item.date_checkin,
            statusLock: item.is_locked,
            is_bandit: item.is_bandit,
          });
        });
        setItems2({
          ...items2,
          list: result,
          total: res.total,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTableLoading2(false);
    }
  };

  useEffect(() => {
    getItems2();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params2]);

  return (
    <>
      {contextHolder}

      <Layout contentClassName="member-content">
        <BreadcrumbBlock
          items={[
            {
              title: (
                <Flex align="center" gap={16}>
                  <Home2 variant="Bulk" />
                  <Link to="/">CMD Tech</Link>
                </Flex>
              ),
            },
            { title: "Member" },
          ]}
          title="Member"
          description=""
        />

        <div className="table-filter-block">
          <Input
            placeholder="Search by name, appid"
            prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
            className="rs-input w-349 grid-area-search"
            allowClear
            onPressEnter={(e) => onEnter(e)}
            onChange={(e) => onChange(e)}
          />
          {(currentTab === "1" || currentTab === "2") && (
            <>
              <Select
                defaultValue={""}
                options={roles}
                placeholder="Role"
                popupMatchSelectWidth={false}
                allowClear={params.roleSearch !== ""}
                suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
                className="rs-select w-186 grid-area-role"
                labelRender={customSelectedLabel}
                onChange={onRoleChange}
              />
              {currentTab === "1" && (
                <Input
                  placeholder="Shift"
                  allowClear
                  prefix={<Clock size={20} variant="Bulk" />}
                  className="rs-input w-186 grid-area-shift"
                  type="Number"
                  onPressEnter={(e) => onShiftEnter(e)}
                  onChange={(e) => onShiftChange(e)}
                />
              )}
              <Select
                defaultValue={null}
                options={levels}
                placeholder="Level"
                allowClear={params.levelSearch !== ""}
                popupMatchSelectWidth={false}
                suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
                className="rs-select w-186 grid-area-level"
                onChange={onFilterLevel}
              />
              <Select
                defaultValue={null}
                options={[
                  { value: "0", label: "Palm scan" },
                  { value: "1", label: "Manual" },
                ]}
                placeholder="Entry Method"
                allowClear={params.entryMethodSearch !== ""}
                popupMatchSelectWidth={false}
                suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
                className="rs-select w-186 grid-area-entry-method"
                onChange={onFilterEntryMethod}
              />
            </>
          )}

          {currentTab === "2" && (
            <Button
              icon={<DocumentDownload size={20} variant="Bulk" />}
              className="rs-button grid-area-export"
              loading={exportPalmLoading}
              onClick={handleExportPalmImages}
            >
              Export Palm Images
            </Button>
          )}

          <Button
            icon={<DocumentDownload size={20} variant="Bulk" />}
            className="rs-button grid-area-export"
            loading={exportLoading}
            onClick={getItemsByExcel}
          >
            Export
          </Button>
        </div>

        <Tabs
          activeKey={currentTab}
          items={tabs}
          className="rs-tabs rs-tabs--no-tab-content"
          onChange={onTabChange}
        />
        <div className="totalMatchToday">
          <div className="text">Total bandits: {items0.total_bandit}</div>
          <div className="text">Total member: {items0.total}</div>
          <div className="text">Total match today: {totalMatchToday}</div>
        </div>
        {currentTab === "1" && (
          <Table
            columns={columns}
            dataSource={items.list}
            className="rs-table table-text-nowrap t-table-member"
            loading={tableLoading}
            scroll={{
              x: true,
            }}
            showSorterTooltip={false}
            tableLayout="fixed"
            pagination={{
              current: params.page_number,
              pageSize: params.limit,
              position: ["bottomCenter"],
              showSizeChanger: true,
              showTitle: false,
              total: items.total,
              itemRender: customPrevNext,
              onChange: (e) => onPageChange(e),
            }}
            onChange={onTableChange}
          />
        )}
        {currentTab === "2" && (
          <Table
            columns={columns0}
            dataSource={items0.list}
            className="rs-table table-text-nowrap t-table-member"
            loading={tableLoading0}
            scroll={{
              x: true,
            }}
            showSorterTooltip={false}
            tableLayout="fixed"
            pagination={{
              current: params0.page_number,
              pageSize: params0.limit,
              position: ["bottomCenter"],
              showSizeChanger: true,
              showTitle: false,
              total: items0.total,
              itemRender: customPrevNext,
              onChange: (e) => onPageChange0(e),
            }}
            onChange={onTableChange0}
          />
        )}

        {currentTab === "3" && (
          <Table
            columns={columns2}
            dataSource={items2.list}
            className="rs-table table-text-nowrap t-table-member"
            loading={tableLoading2}
            scroll={{
              x: true,
            }}
            showSorterTooltip={false}
            tableLayout="fixed"
            pagination={{
              current: params2.page_number,
              pageSize: params2.limit,
              position: ["bottomCenter"],
              showSizeChanger: true,
              showTitle: false,
              total: items2.total,
              itemRender: customPrevNext,
              onChange: (e) => onPageChange2(e),
            }}
            onChange={onTableChange2}
          />
        )}

        <HistoryPopup
          id={selectedId}
          isShow={showHistoryPopup}
          onPopupClose={() => setShowHistoryPopup(false)}
        />

        <LockModal
          isShow={showLockPopup}
          content={`Are you sure you want to ${
            selectedItem?.statusLock === 1 ? "accept" : "lock"
          } this member?`}
          message="Member updated!"
          apiUrl="/api/webAdmin/updateBlockMember.php"
          param={{
            customer_id: selectedItem?.customer_id,
            is_locked: selectedItem?.is_locked === 1 ? 0 : 1,
          }}
          type={selectedItem?.statusLock === 1 ? "unlock" : "lock"}
          onModalClose={() => setShowLockPopup(false)}
          onModalSubmit={() => {
            getItems();
            getItems0();
            getItems2();
            setShowLockPopup(false);
          }}
        />
        <LockModal
          isShow={showBanPopup}
          content={`Are you sure you want to ${
            selectedItem?.is_bandit === 1 ? "unbanned" : "banned"
          } this member?`}
          message="Member updated!"
          apiUrl="/api/webAdmin/banditCustomerById.php"
          param={{
            customer_id: selectedItem?.customer_id,
            is_bandit: selectedItem?.is_bandit === 1 ? 0 : 1,
          }}
          type={selectedItem?.is_bandit === 1 ? "unban" : "ban"}
          onModalClose={() => setShowBanPopup(false)}
          onModalSubmit={() => {
            getItems();
            getItems0();
            getItems2();
            setShowBanPopup(false);
          }}
        />

        <EditLevelModal
          isShow={modalData.show}
          param={modalData.data}
          apiUrl="/api/webAdmin/updateBlockMember.php"
          message="Member updated!"
          onModalClose={() =>
            setModalData({ ...modalData, show: false, data: {} })
          }
          onModalSubmit={() => {
            getItems();
            getItems0();
            getItems2();
            setModalData({ ...modalData, show: false, data: {} });
          }}
        />

        <EditMemberPopup
          id={selectedId}
          isShow={showEditMemberPopup}
          onPopupClose={() => setShowEditMemberPopup(false)}
          onSuccess={() => {
            getItems();
            getItems0();
            setShowEditMemberPopup(false);
          }}
        />

        <AddMemberModal
          isShow={showAddMemberModal}
          buttonText="Send SMS"
          onPopupClose={() => setShowAddMemberModal(false)}
          onAddMember={(players) => {
            setShowAddMemberModal(false);
            setShowSendSMSModal(true);
            setSmsMembers(players);
          }}
        />

        <SendMessageModal
          isShow={showSendSMSModal}
          customers={smsMembers}
          onPopupClose={() => setShowSendSMSModal(false)}
          onSend={() => {
            setShowSendSMSModal(false);
          }}
        />

        <MemberDetailInfomationPoup
          memberData={infoCustomer}
          isShow={showMemberInfoPopup}
          onClose={() => setShowMemberInfoPopup(false)}
          loading={loading}
          historyMatch={historyMatch}
          historyLuckyGame={historyLuckyGame}
          paramsMatch={paramsMatch}
          onPageMatchChange={onPageMatchChange}
          onTableMatchChange={onTableMatchChange}
          onPageGameChange={onPageGameChange}
          onTableGameChange={onTableGameChange}
          comboLimit={comboLimit}
          updateLimitMember={updateLimitMember}
          updateHourMatchMember={updateHourMatchMember}
        />
      </Layout>
    </>
  );
};

export default Member;
